// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';
import { type ColombianDocumentType } from '../types';

export function validateColombianDocument(document: string, documentType: ColombianDocumentType): ?UserInputValidationError {
  switch(documentType){
    case 'NIT':
      return validateNit(document);

    case 'CC':
      return validateCc(document);

    case 'CE':
      return validateCe(document);

    default:
      return { id: 'empty' };
  }
}

function validateCc(document: string): ?UserInputValidationError {
  if (!document) {
    return { id: 'empty'};
  } else if (!/^[1-9][0-9]{1,9}$/.test(document)) {
    return { id: 'invalid-pattern' };
  }
}

function validateNit(document: string): ?UserInputValidationError {
  if (!document) {
    return { id: 'empty'};
  } else if (!/^\d{9,15}$/.test(document)) {
    return { id: 'invalid-pattern' };
  }
}

function validateCe(document: string): ?UserInputValidationError {
  if (!document) {
    return { id: 'empty'};
  } else if (!/^\d{1,7}$/.test(document)) {
    return { id: 'invalid-pattern' };
  }
}
